export default __webpack_public_path__ + "static/flag-argentina-c851a0f3db922e8275c2f58c8d518005.svg";